(function () {
  const quizData = [
    { key: 'age', title: 'Età', type: 'single', choices: ['18–25', '26–34', '35–44', '45+'] },
    { key: 'goal', title: 'Obiettivo principale', type: 'single', choices: ['Ridurre la caduta', 'Migliorare la salute della cute', 'Migliorare densità e volume', 'Prevenire problemi futuri'] },
    { key: 'loss_notice', title: 'Stai notando perdita di capelli?', type: 'single', choices: ['Sì, evidente', 'Sì, leggera', 'Non sono sicuro', 'No'] },
    { key: 'duration', title: 'Da quanto tempo?', type: 'single', choices: ['Meno di 3 mesi', '3–12 mesi', 'Più di un anno'] },
    { key: 'stress', title: 'Livello di stress', type: 'single', choices: ['Alto', 'Medio', 'Basso'] },
    { key: 'sleep', title: 'Qualità del sonno', type: 'single', choices: ['Male / poco', 'Potrebbe essere meglio', 'Bene'] },
    { key: 'nutrition', title: 'Alimentazione', type: 'single', choices: ['Disordinata', 'Abbastanza ok', 'Curata'] },
    { key: 'activity', title: 'Attività fisica', type: 'single', choices: ['No', '1–2 volte settimana', 'Regolarmente'] },
    { key: 'tension', title: 'Tensione corporea', type: 'multi', choices: ['Collo e nuca', 'Mascella', 'Spalle / trapezio', 'Più zone', 'Nessuna'] },
    { key: 'posture', title: 'Postura percepita', type: 'multi', choices: ['Testa in avanti', 'Spalle chiuse', 'Schiena curva', 'Nessuna'] },
    { key: 'tension_when', title: 'Quando senti tensione?', type: 'single', choices: ['Seduto al pc', 'Stress / ansia', 'Fine giornata', 'Sempre'] },
    { key: 'scalp', title: 'Cute', type: 'single', choices: ['Tesa', 'Grassa', 'Secca', 'Normale'] },
    { key: 'treatments', title: 'Trattamenti cute', type: 'single', choices: ['Mai', 'Qualche volta', 'Regolarmente'] }
  ];

  const initQuiz = (container) => {
    const content = container.querySelector('.rs-quiz__content');
    const progressLabel = container.querySelector('.rs-quiz__progress-label');
    const progressFill = container.querySelector('.rs-quiz__progress-fill');

    const loadingStepIndex = quizData.length;
    const emailStepIndex = quizData.length + 1;
    const totalProgressSteps = quizData.length;
    const totalSteps = quizData.length + 2;
    const answers = {};
    let currentStep = 0;
    const screens = [];

    const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value || '').trim());

    const createOption = (text, item, screen) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'rs-quiz__option';
      btn.textContent = text;
      btn.addEventListener('click', () => handleOptionClick(text, item, screen));
      return btn;
    };

    const createScreen = (item, index) => {
      const screen = document.createElement('div');
      screen.className = 'rs-quiz__screen';
      screen.dataset.step = String(index);

      const group = document.createElement('div');
      group.className = 'rs-quiz__question-group';

      const title = document.createElement('div');
      title.className = 'rs-quiz__question-title';
      title.textContent = item.title;
      group.appendChild(title);

      if (item.type === 'multi') {
        const hint = document.createElement('div');
        hint.className = 'rs-quiz__hint';
        hint.textContent = 'Seleziona una o più opzioni, poi continua.';
        group.appendChild(hint);
      }

      const options = document.createElement('div');
      options.className = 'rs-quiz__options';
      item.choices.forEach((choice) => {
        options.appendChild(createOption(choice, item, screen));
      });
      group.appendChild(options);

      if (item.type === 'multi') {
        const cont = document.createElement('button');
        cont.type = 'button';
        cont.className = 'rs-quiz__button';
        cont.textContent = 'Continua';
        cont.disabled = true;
        cont.dataset.multi = 'continue';
        cont.addEventListener('click', () => nextStep());
        group.appendChild(cont);
      }

      screen.appendChild(group);
      return screen;
    };

    const createEmailScreen = () => {
      const screen = document.createElement('div');
      screen.className = 'rs-quiz__screen';
      screen.dataset.step = String(emailStepIndex);

      const group = document.createElement('div');
      group.className = 'rs-quiz__question-group';

      const title = document.createElement('div');
      title.className = 'rs-quiz__question-title';
      title.textContent = 'Ritira i tuoi risultati';
      group.appendChild(title);

      const form = document.createElement('div');
      form.className = 'rs-quiz__form-group';

      const input = document.createElement('input');
      input.className = 'rs-quiz__input';
      input.type = 'email';
      input.placeholder = 'Inserisci la tua email';
      input.autocomplete = 'email';

      const error = document.createElement('div');
      error.className = 'rs-quiz__error';
      error.textContent = '';

      const action = document.createElement('button');
      action.type = 'button';
      action.className = 'rs-quiz__button';
      action.textContent = 'Mostra risultato';
      action.disabled = true;

      input.addEventListener('input', () => {
        action.disabled = !validateEmail(input.value);
        error.textContent = '';
      });

      action.addEventListener('click', () => {
        if (!validateEmail(input.value)) {
          error.textContent = 'Inserisci un indirizzo email valido.';
          return;
        }
        answers.email = input.value.trim();
        showFinal();
      });

      form.appendChild(input);
      form.appendChild(error);
      form.appendChild(action);
      group.appendChild(form);
      screen.appendChild(group);
      return screen;
    };

    const createLoadingScreen = () => {
      const screen = document.createElement('div');
      screen.className = 'rs-quiz__screen';
      screen.dataset.step = String(loadingStepIndex);

      const wrap = document.createElement('div');
      wrap.className = 'rs-quiz__loading';

      const spinner = document.createElement('div');
      spinner.className = 'rs-quiz__spinner';

      const title = document.createElement('div');
      title.className = 'rs-quiz__loading-title';
      title.textContent = 'Stiamo valutando il tuo caso';

      const text = document.createElement('div');
      text.className = 'rs-quiz__loading-text';
      text.textContent = 'Meno di 1 minuto mancante prima di mostrarti il risultato finale.';

      wrap.appendChild(spinner);
      wrap.appendChild(title);
      wrap.appendChild(text);
      screen.appendChild(wrap);
      return screen;
    };

    const createFinalScreen = () => {
      const screen = document.createElement('div');
      screen.className = 'rs-quiz__screen';
      screen.dataset.step = 'final';

      const wrap = document.createElement('div');
      wrap.className = 'rs-quiz__final';

      const title = document.createElement('div');
      title.className = 'rs-quiz__final-title';
      title.textContent = 'Analisi completata';

      const text = document.createElement('div');
      text.className = 'rs-quiz__final-text';
      text.textContent = 'Abbiamo raccolto le tue risposte per offrirti una proposta RadianceSkin studiata per la salute dei tuoi capelli.';

      const link = document.createElement('a');
      link.className = 'rs-quiz__link';
      link.href = '/collections/all';
      link.textContent = 'Scopri RadianceSkin';

      wrap.appendChild(title);
      wrap.appendChild(text);
      wrap.appendChild(link);
      screen.appendChild(wrap);
      return screen;
    };

    const handleOptionClick = (choice, item, screen) => {
      if (item.type === 'single') {
        answers[item.key] = choice;
        markSelected(screen, choice, item.type);
        setTimeout(() => nextStep(), 220);
        return;
      }

      const existing = new Set(answers[item.key] || []);
      if (existing.has(choice)) existing.delete(choice);
      else existing.add(choice);

      answers[item.key] = Array.from(existing);
      markSelected(screen, existing, item.type);

      const cont = screen.querySelector('[data-multi="continue"]');
      if (cont) cont.disabled = existing.size === 0;
    };

    const markSelected = (screen, value, type) => {
      const buttons = screen.querySelectorAll('.rs-quiz__option');
      buttons.forEach((btn) => {
        const text = btn.textContent;
        if (type === 'single') {
          btn.classList.toggle('rs-quiz__option--selected', text === value);
        } else {
          btn.classList.toggle('rs-quiz__option--selected', value.has(text));
        }
      });
    };

    const nextStep = () => {
      const nextIndex = currentStep + 1;

      if (nextIndex === loadingStepIndex) {
        currentStep = nextIndex;
        showStep(currentStep);

        setTimeout(() => {
          currentStep = emailStepIndex;
          showStep(emailStepIndex);
        }, 8000);

        return;
      }

      if (nextIndex <= emailStepIndex) {
        currentStep = nextIndex;
        showStep(currentStep);
      }
    };

    const normalizeAnswer = (value) => String(value || '').trim().toLowerCase();

    const getInitialScores = () => ({
      stressScore: 0,
      sleepScore: 0,
      lifestyleScore: 0,
      scalpScore: 0,
      lossScore: 0,
      durationScore: 0,
      tensionScore: 0,
      postureScore: 0
    });

    const isQuizComplete = () => {
      return quizData.every((item) => {
        const value = answers[item.key];
        if (item.type === 'multi') {
          return Array.isArray(value) && value.length > 0;
        }
        return value !== undefined && value !== '';
      });
    };

    const calculateQuizScores = (answersPayload) => {
      const scores = getInitialScores();
      const add = (key, value) => {
        if (typeof scores[key] === 'number') scores[key] += value;
      };

      const answer = (key) => normalizeAnswer(answersPayload[key]);

      switch (answer('stress')) {
        case 'alto': add('stressScore', 2); break;
        case 'medio': add('stressScore', 1); break;
        default: break;
      }

      switch (answer('sleep')) {
        case 'male / poco': add('sleepScore', 2); break;
        case 'potrebbe essere meglio': add('sleepScore', 1); break;
        default: break;
      }

      switch (answer('nutrition')) {
        case 'disordinata': add('lifestyleScore', 2); break;
        case 'abbastanza ok': add('lifestyleScore', 1); break;
        default: break;
      }

      switch (answer('activity')) {
        case 'no': add('lifestyleScore', 2); break;
        case '1–2 volte settimana': add('lifestyleScore', 1); break;
        default: break;
      }

      switch (answer('loss_notice')) {
        case 'sì, evidente': add('lossScore', 3); break;
        case 'sì, leggera': add('lossScore', 1); break;
        case 'non sono sicuro': add('lossScore', 1); break;
        default: break;
      }

      switch (answer('duration')) {
        case 'meno di 3 mesi': add('durationScore', 1); break;
        case '3–12 mesi': add('durationScore', 2); break;
        case 'più di un anno': add('durationScore', 3); break;
        default: break;
      }

      switch (answer('scalp')) {
        case 'tesa': add('scalpScore', 2); break;
        case 'grassa': add('scalpScore', 1); break;
        case 'secca': add('scalpScore', 1); break;
        default: break;
      }

      switch (answer('treatments')) {
        case 'mai':
          add('scalpScore', 1);
          add('lifestyleScore', 1);
          break;
        case 'qualche volta':
          add('scalpScore', 1);
          break;
        default:
          break;
      }

      const tensionAnswers = Array.isArray(answersPayload.tension) ? answersPayload.tension : [];
      tensionAnswers.forEach((item) => {
        const normalized = normalizeAnswer(item);
        if (normalized === 'più zone') add('tensionScore', 2);
        else if (normalized !== 'nessuna') add('tensionScore', 1);
      });

      const postureAnswers = Array.isArray(answersPayload.posture) ? answersPayload.posture : [];
      postureAnswers.forEach((item) => {
        if (normalizeAnswer(item) !== 'nessuna') add('postureScore', 1);
      });

      switch (answer('tension_when')) {
        case 'sempre': add('tensionScore', 2); break;
        case 'stress / ansia': add('tensionScore', 2); break;
        case 'fine giornata': add('tensionScore', 1); break;
        case 'seduto al pc': add('tensionScore', 1); break;
        default: break;
      }

      if (answer('goal').includes('prevenire')) {
        add('lifestyleScore', 1);
      }

      return scores;
    };

    const resolveQuizRoute = (scores, answersPayload) => {
      const { stressScore, sleepScore, lifestyleScore, scalpScore, lossScore, durationScore, tensionScore, postureScore } = scores;
      const totalAxes = stressScore + sleepScore + lifestyleScore + scalpScore + lossScore + durationScore + tensionScore + postureScore;
      const complexPoints = [stressScore, sleepScore, scalpScore, lossScore, tensionScore, postureScore].filter((value) => value >= 2).length;

      if (lossScore >= 3 && durationScore >= 3) {
        return '/pages/result_4';
      }

      if ((stressScore >= 3 && tensionScore >= 2) || (tensionScore >= 3 && postureScore >= 2) || (stressScore >= 3 && sleepScore >= 2)) {
        return '/pages/result_3';
      }

      if (scalpScore >= 2 && lossScore <= 2) {
        return '/pages/result_5';
      }

      if (lossScore <= 1 && normalizeAnswer(answersPayload.goal).includes('prevenire')) {
        return '/pages/result_1';
      }

      if (lossScore >= 2 && durationScore <= 2) {
        return '/pages/result_2';
      }

      if (complexPoints >= 3 || totalAxes >= 10) {
        return '/pages/result_6';
      }

      return '/pages/result_2';
    };

    const showFinal = () => {
      if (!isQuizComplete()) {
        console.warn('Quiz incompleto, impossibile determinare il risultato:', answers);
        return;
      }

      const scores = calculateQuizScores(answers);
      const route = resolveQuizRoute(scores, answers);

      console.log('quiz scores', scores);
      console.log('quiz final route', route);

      currentStep = totalSteps;
      updateProgress(totalProgressSteps);
      screens.forEach((s) => s.classList.remove('rs-quiz__screen--active'));

      const finalScreen = container.querySelector('[data-step="final"]');
      if (finalScreen) {
        finalScreen.classList.add('rs-quiz__screen--active');
        const link = finalScreen.querySelector('.rs-quiz__link');
        if (link) link.href = route;
      }

      sendToGoogleSheet(Object.assign({}, answers));

      setTimeout(() => {
        window.location.href = route;
      }, 140);
    };

    const showStep = (index) => {
      updateProgress(index);

      screens.forEach((s) => {
        if (String(s.dataset.step) === String(index)) {
          s.classList.remove('rs-quiz__screen--exit');
          s.classList.add('rs-quiz__screen--active');
        } else {
          s.classList.remove('rs-quiz__screen--active');
        }
      });

      if (String(index) === String(emailStepIndex)) {
        const emailScreen = container.querySelector(`[data-step="${emailStepIndex}"]`);
        if (emailScreen) {
          const input = emailScreen.querySelector('.rs-quiz__input');
          if (input) setTimeout(() => input.focus(), 220);
          setTimeout(() => {
            try {
              container.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) {}
          }, 50);
        }
      }
    };

    const updateProgress = (stepIndex) => {
      const pct = Math.min(
        100,
        Math.round((Math.min(stepIndex, totalProgressSteps) / totalProgressSteps) * 100)
      );
      progressLabel.textContent = pct + '% completato';
      progressLabel.dataset.pct = pct + '%';
      progressFill.style.width = pct + '%';
    };

    const sendToGoogleSheet = (payload) => {
      const body = new URLSearchParams();
      Object.keys(payload).forEach((key) => {
        body.append(key, JSON.stringify(payload[key] ?? ''));
      });
      body.append('timestamp', new Date().toISOString());

      setTimeout(() => {
        fetch('https://script.google.com/macros/s/AKfycbwqEsxEW8G0owRwON9b9r0gBa-OCu3anQWY5Zir0X6e2q689KAbwRxnYS2WB7QaJh9m/exec', {
          method: 'POST',
          body: body
        }).catch((err) => console.log('send error', err));
      }, 50);
    };

    content.innerHTML = '';
    quizData.forEach((item, idx) => {
      const s = createScreen(item, idx);
      screens.push(s);
      content.appendChild(s);
    });

    const loadingScreen = createLoadingScreen();
    screens.push(loadingScreen);
    content.appendChild(loadingScreen);

    const emailScreen = createEmailScreen();
    screens.push(emailScreen);
    content.appendChild(emailScreen);

    content.appendChild(createFinalScreen());

    showStep(0);
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.rs-quiz').forEach(initQuiz);
  });
})();